module.exports = __webpack_public_path__ + "img/Bio_2.3a34ec54.jpg";